import React from "react"
import "../style/landingPage.css"


export default function LandingPage (props)
{


    return(
        <div className="landing_page_container" id="landingPage">
            <div className="landing_page_box">
                <div className="header_box">
                <h3 className="header">butifuly crafted web experiences</h3>
                <h3 className="subHeader_landing_pag">Full Stack Developer</h3>
                <div className="scroll_ico">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="77" viewBox="0 0 40 77">
  <g id="scroll" >
    <g id="Rectangle_12" data-name="Rectangle 12" transform="translate(253 787)" fill="none" stroke="#fff" stroke-width="4">
      <rect width="40" height="77" rx="20" fill="#fff" stroke="#fff"/>
      <rect className="scroll_ball" x="2" y="2" width="36" height="73" rx="18" stroke="#fff" fill="none"/>
    </g>
    <circle className="landing_page_circle" id="Ellipse_1" data-name="Ellipse 1" cx="11" cy="11" r="11" transform="translate(262 798)" fill="#fff"/>
  </g>
</svg>
                </div>
                </div>
                
            </div>
            <div className="shapes">
                <div className="svg_box">
<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 686 688">
  <g className="blockdesign" transform="translate(-935 -289) ">
    <rect className="rect" id="Rectangle_2" data-name="Rectangle 2"  rx="19" transform="translate(1277 289)" fill="#6e00ff"/>
    {/* <rect className="rect" id="Rectangle_2" data-name="Rectangle 2"  rx="19" transform="translate(1277 289)" fill="#6e00ff"/> */}
    <rect className="rect circle" id="Rectangle_10" data-name="Rectangle 10"  rx="86" transform="translate(1277 461)" fill="rgb(225, 173, 1)"/>
    <rect className="rect" id="Rectangle_8" data-name="Rectangle 8"  rx="19" transform="translate(1449 461)" fill="rgb(15, 187, 158,0.7)"/>
    <rect className="rect" id="Rectangle_5" data-name="Rectangle 5"  rx="19" transform="translate(1277 633)" fill="#6e00ff"/>
    <rect className="rect" id="Rectangle_3" data-name="Rectangle 3"  rx="19" transform="translate(1107 461)" fill="#fff"/>
    <rect className="rect circle" id="Rectangle_9" data-name="Rectangle 9"  rx="86" transform="translate(1107 633)" fill="#00f7ff"/>
    <rect className="rect" id="Rectangle_7" data-name="Rectangle 7"  rx="19" transform="translate(935 633)" fill="#fff" opacity="0.17"/>
    <rect className="rect" id="Rectangle_4" data-name="Rectangle 4"  rx="19" transform="translate(1107 805)" fill="#fff"/>
  </g>
</svg>
</div>
                </div>
        </div>
    )
}


